import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  PropositionService,
  CommentService,
  AccountService,
} from '@arkius/shared-api';
import { NavController } from '@ionic/angular';
import { take } from 'rxjs';

@Component({
  selector: 'ark-lib-proposition-notification',
  templateUrl: './proposition-notification.component.html',
  styleUrl: './proposition-notification.component.css',
})
export class PropositionNotificationComponent {
  // readMore = false;
  isExpanded = false;
  accountNickname!: string;

  @Input() notification: any;
  @Output() dismiss = new EventEmitter<number>();

  constructor(
    private propositionService: PropositionService,
    private accountService: AccountService,
  ) {
    this.getAccountDetails();
  }

  onNotificationReadMore(notificationId: number) {
    this.propositionService
      .apiV5PropositionTimelineSystemNotificationOpenIdGet(notificationId)
      .pipe(take(1))
      .subscribe((data) => {
        this.notification.description = data.description;
        // this.readMore = true;
        // environment.log('notification', this.notification);
      });
  }

  ExpandText() {
    this.isExpanded = !this.isExpanded;
  }

  handleReadMore(systemNotificationId: number) {
    this.ExpandText();
    this.onNotificationReadMore(systemNotificationId);
  }

  getAccountDetails() {
    this.accountService
      .apiV5AccountProfileGet()
      .pipe(take(1))
      .subscribe((data) => {
        this.accountNickname = data.nickname;
      });
  }
  goToCommunityGuidelines() {
    window.open(
      'https://www.thesolutionsmovement.org/community-guidelines/',
      '_blank',
    );
  }
}
